import { AvatarNameEmail } from 'common-front/src/components/avatarNameEmail';
import { DropdownEllipsis } from 'common-front/src/designSystem/components/dropdown/dropdownEllipsis';
import { ItemIcon } from 'common-front/src/designSystem/components/dropdown/item';
import { Content } from 'common-front/src/designSystem/components/tooltip/content';
import { Tooltip } from 'common-front/src/designSystem/components/tooltip/tooltip';
import { Trigger } from 'common-front/src/designSystem/components/tooltip/trigger';
import {
    useEmailResendMutation,
    useUsersInfosMassCampaignSendMutation
} from 'common-front/src/generated/graphqlHooks';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Badge } from 'common/src/designSystem/components/badge';
import { Box } from 'common/src/designSystem/components/box';
import { Cell } from 'common/src/designSystem/components/table/cell';
import { CellControls } from 'common/src/designSystem/components/table/cellControls';
import { Row } from 'common/src/designSystem/components/table/row';
import { EmailRecipientFragment, EmailState, EmailType } from 'common/src/generated/types';
import { DateTimeService } from 'common/src/services/dateTimeService';
import { useService } from 'common/src/util/dependencies/dependencies';
import { Emptyable } from 'common/src/util/emptyable';
import { LocaleFormats } from 'common/src/util/luxon';
import { isNonEmptyString } from 'common/src/util/string';
import { getStateBadgeColorIcon } from 'common/src/vo/email';
import * as React from 'react';

interface ICampaignEmailRowProps {
    email: EmailRecipientFragment;
    emailType: Emptyable<EmailType>;

    reload(): void;
}

export const CampaignEmailRow = (props: ICampaignEmailRowProps) => {
    const {
        translate,
        params: { organizationId, eventId, campaignId }
    } = useHeavent();
    const dateTimeService = useService(DateTimeService);
    const { mutate: massCampaignSend } = useUsersInfosMassCampaignSendMutation();
    const { mutate: emailResend } = useEmailResendMutation();

    return (
        <Row>
            <Cell>
                <AvatarNameEmail userInfo={props.email.userInfo} />
            </Cell>

            <Cell>
                {props.email.sentAt
                    ? dateTimeService.toLocaleString(
                          props.email.sentAt.toLocal(),
                          LocaleFormats.DateTime
                      )
                    : ''}
            </Cell>

            <Cell>
                {props.email.state === EmailState.Bounced &&
                isNonEmptyString(props.email.infos?.bounceDiagnosticCode) ? (
                    <Tooltip>
                        <Trigger>
                            <Box>
                                <Badge {...getStateBadgeColorIcon(props.email.state)}>
                                    {translate(props.email.state)}
                                </Badge>
                            </Box>
                        </Trigger>

                        <Content placement="top">{props.email.infos.bounceDiagnosticCode}</Content>
                    </Tooltip>
                ) : (
                    <Badge {...getStateBadgeColorIcon(props.email.state)}>
                        {translate(props.email.state)}
                    </Badge>
                )}
            </Cell>

            <CellControls justify="end">
                <DropdownEllipsis>
                    <ItemIcon
                        icon="paper-plane"
                        onClick={async () => {
                            if (props.emailType) {
                                await emailResend({
                                    organizationId,
                                    eventId,
                                    userInfoId: props.email.userInfo.id,
                                    emailType: props.emailType
                                });
                            } else {
                                await massCampaignSend({
                                    organizationId,
                                    eventId,
                                    campaignId,
                                    selecteds: { ids: [props.email.userInfo.id] }
                                });
                            }

                            props.reload();
                        }}
                    >
                        {translate('r_envoyer_90741')}
                    </ItemIcon>
                </DropdownEllipsis>
            </CellControls>
        </Row>
    );
};
